import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-float-label p-m-4" }
const _hoisted_2 = {
  for: "mailTo",
  class: "kn-material-input-label"
}
const _hoisted_3 = { id: "chips-help" }
const _hoisted_4 = { class: "p-float-label p-m-4" }
const _hoisted_5 = {
  for: "mailSubject",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Editor = _resolveComponent("Editor")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("span", _hoisted_1, [
      _createVNode(_component_AutoComplete, {
        id: "mailTo",
        class: "p-inputtext-sm",
        multiple: true,
        modelValue: _ctx.selectedUsers,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedUsers = $event)),
        suggestions: _ctx.filteredUsers,
        field: "name",
        onKeydown: _withKeys(_ctx.createMailChip, ["enter"]),
        onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchUsers($event))),
        onItemSelect: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setUser($event.value)))
      }, null, 8, ["modelValue", "suggestions", "onKeydown"]),
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('kpi.alert.mailTo')), 1),
      _createVNode("small", _hoisted_3, _toDisplayString(_ctx.$t('common.chipsHint')), 1)
    ]),
    _createVNode("span", _hoisted_4, [
      _createVNode(_component_InputText, {
        id: "mailSubject",
        class: "kn-material-input",
        modelValue: _ctx.selectedAction.jsonActionParameters.subject,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedAction.jsonActionParameters.subject = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["modelValue"]),
      _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('kpi.alert.mailSubject')), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("span", null, [
        _createVNode(_component_Editor, {
          id: "html",
          modelValue: _ctx.selectedAction.jsonActionParameters.body,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedAction.jsonActionParameters.body = $event)),
          editorStyle: _ctx.sendMailCardDescriptor.editor.style
        }, null, 8, ["modelValue", "editorStyle"])
      ])
    ])
  ], 64))
}